
export function randomString(length = 16) {
  let result = ''
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() *
      charactersLength))
  }
  return result
}

export function filterRakutenFromConditions(list) {
  const companyCd = sessionStorage.getItem('companyCd') || ''
  const disableRakuten = companyCd !== '' &&
    process.env.VUE_APP_DISABLE_RAKUTEN_TRAVEL
      ?.split(',')
      .includes(companyCd)

  if (!disableRakuten) {
    return list
  }

  return list.map(d => {
    if (d.id !== 'planByCompany') return d

    return {
      ...d,
      list: d.list.filter(item => item.id !== 'isRakuten')
    }
  })
}